import { Column } from '@tanstack/react-table';

/**
 * 고정된 열의 스타일을 적용합니다.
 *
 * @template T - 테이블 데이터 타입
 * @param  column - 테이블의 열 객체
 * @returns - 고정된 열의 스타일 객체
 */
export function getCommonPinningStyles<T>(column: Column<T>): {
  boxShadow: string | undefined;
  left: string | undefined;
  position: string;
  zIndex: number;
  width: number;
} {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn = isPinned === 'left' && column.getIsLastColumn('left');
  const isFirstRightPinnedColumn = isPinned === 'right' && column.getIsFirstColumn('right');

  return {
    boxShadow: isLastLeftPinnedColumn
      ? '-4px 0 4px -4px gray inset'
      : isFirstRightPinnedColumn
        ? '4px 0 4px -4px gray inset'
        : undefined,
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    zIndex: isPinned ? 1 : 0,
    width: column.getSize(),
  };
}
